import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import { ThemeProvider } from 'styled-components'
import { theme } from '../utils'
import Meet from './home/Meet'
import Footer from './common/Footer'

// import Header from './header'
import './layout.css'
import '../utils/fonts'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const Layout = ({ children }) => (
  <StaticQuery
    query={QUERY}
    render={({ site, footer, meet }) => (
      <>
        <Helmet
          title={site.siteMetadata.title}
          meta={[
            {
              name: 'description',
              content: `${site.siteMetadata.description}`,
            },
            { name: 'keywords', content: 'sample, something' },
          ]}
        >
          <html lang="en" />
        </Helmet>
        <ThemeProvider theme={theme}>
          <React.Fragment>
            {children}
            <Meet {...meet.edges[0].node} />
            <Footer {...footer.edges[0].node} />
          </React.Fragment>
        </ThemeProvider>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

const QUERY = graphql`
  {
    site {
      siteMetadata {
        title
        description
      }
    }
    meet: allContentfulHomeMeet {
      edges {
        node {
          id
          meetTitle
          meetSubtitle
          meetBackground {
            fluid(maxWidth: 2560) {
              ...GatsbyContentfulFluid
            }
          }
          meetImage {
            fluid(maxWidth: 800) {
              # ...GatsbyContentfulFluid
              ...GatsbyContentfulFluid_noBase64
            }
          }
        }
      }
    }

    footer: allContentfulFooter {
      edges {
        node {
          id
          footerSections {
            id
            footerLinks {
              childMarkdownRemark {
                html
              }
            }
          }
        }
      }
    }
  }
`

export default Layout
